import api from "../api";
import apifirst from "../apifirst";


const authService = {
    login: async function (email, password, pushToken) {
        const data = { email, password, push_token: pushToken }
        const response = await api.request({
          url: "/auth/login",
          method: "POST",
          data: data
        })
    
        // returning the product returned by the API
        return response.data
    },
    recovery: async function (email) {
        const data = { email, via: 'app' }
        const response = await api.request({
          url: "/auth/recovery",
          method: "POST",
          data: data
        })
    
        // returning the product returned by the API
        return response.data
    },
    setNewPassword: async function (model) {
      const response = await api.request({
        url: "/users/change-password",
        method: "POST",
        data: model
      })

      return response.data
  },
  setFirstPassword: async function (model) {
    const response = await apifirst.request({
      url: "/users/change-password",
      method: "POST",
      data: model
    })

    return response.data
  },
  setResetPassword: async function (model) {
    const response = await apifirst.request({
      url: "/auth/reset",
      method: "POST",
      data: model
    })

    return response.data
  },
  getOperationDetailById: async function (token) {
    const response = await apifirst.request({
      url: "/esco-operation-details/get-operations/by-id/"+token+"?include=escoOperation,escoOperationStatus",
      method: "GET",
    })

    return response.data
  },
  getOperationFundsById: async function (token) {
    const response = await apifirst.request({
      url: "/fund-operations/to-notificate/operation/"+token,
      method: "GET",
    })

    return response.data
  },
  setOperationDetailSign: async function (model) {
    const response = await apifirst.request({
      url: "/esco-and-fund-operations/sign-operations",
      method: "POST",
      data: model
    })

    return response.data
  }

}
  
export default authService;